import { Component } from "@angular/core";

// Import navigation elements
import { navigation } from "../../../../_nav";
import { AppSidebarNavTitleComponent } from "./app-sidebar-nav-title/app-sidebar-nav-title.component";
import { AppSidebarNavItemComponent } from "./app-sidebar-nav-item/app-sidebar-nav-item.component";

@Component({
  selector: "app-sidebar-nav",
  standalone: true,
  template: ` <nav class="sidebar-nav">
    @for(navitem of navigation; track $index) { @if(isDivider(navitem)) {
    <div class="nav-divider"></div>
    } @else if(isTitle(navitem)) {
    <app-sidebar-nav-title [title]="navitem"></app-sidebar-nav-title>
    } @else {
    <app-sidebar-nav-item [item]="navitem"></app-sidebar-nav-item>
    } }
  </nav>`,
  styles: [
    `
      .sidebar-nav {
        height: 100%;
        overflow-x: visible !important;
        overflow-y: visible !important;
      }
    `,
  ],
  imports: [AppSidebarNavTitleComponent, AppSidebarNavItemComponent],
})
export class AppSidebarNavComponent {
  public navigation = navigation;

  public isDivider(item: any) {
    return item.divider ? true : false;
  }

  public isTitle(item: any) {
    return item.title ? true : false;
  }

  constructor() {}
}
